import { createAction } from '@reduxjs/toolkit';
import { TopProps } from '../../types/WidgetProps';

export const updateTopProps = createAction<TopProps>('UPDATE_TPA_PROPS');
